import {
  formatDate,
  formatPrice,
  formatTime,
  formatDatetime,
  formatCalendarDatetime,
  formatTimeRoundupSecond,
  sumTimeClockEntries,
  timestampToTime,
  roundUp,
  momentLocal,
  localToUtc,
  stripTags,
} from "src/utils/helpers";
import UTIL from "src/helpers/utility";

export default {
  data() {
    return {};
  },
  computed: {},

  filters: {
    stripTags: function(string) {
      return stripTags(string);
    },
    roundUp: function(value) {
      return roundUp(value);
    },
    formatPrice: function(value) {
      return formatPrice(value);
    },
    formatDate: function(value) {
      return formatDate(value);
    },
    formatTime: function(value) {
      return formatTime(value);
    },
    formatDatetime: function(value) {
      return formatDatetime(value);
    },
    formatCalendarDatetime: function(value, isAllDay) {
      return formatCalendarDatetime(value, isAllDay);
    },
    formatTimeRoundupSecond: function(value, eightHourDays = false) {
      return formatTimeRoundupSecond(value, eightHourDays);
    },
  },
  methods: {
    timestampToTime(value) {
      return timestampToTime(value);
    },
    momentLocal(value) {
      return momentLocal(value);
    },
    localToUtc(value) {
      return localToUtc(value);
    },

    sumTimeClockEntries(timeClockEntries) {
      return sumTimeClockEntries(timeClockEntries);
    },
    roundUp(value) {
      return roundUp(value);
    },
    optional(obj, path) {
      return UTIL.gv(obj, path);
    },
    formatDate(value) {
      return formatDate(value);
    },
    formatPrice(value) {
      return formatPrice(value);
    },
    formatTime(value) {
      return formatTime(value);
    },
    formatDatetime(value) {
      return formatDatetime(value);
    },
    formatCalendarDatetime(value, isAllDay) {
      return formatCalendarDatetime(value, isAllDay);
    },
    formatTimeRoundupSecond: function(value, eightHourDays = false) {
      return formatTimeRoundupSecond(value, eightHourDays);
    },
  },
};
